import React from 'react'
import styles from './status-connected.styles'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import StatusColor from '../shared/status-color/status-color'
import UnlinkIcon from 'react-icons/lib/fa/chain-broken'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import PobbleLink from 'pobble-components/dist/pobble-link'

const StatusConnected = ({ classes, id, statusColor, onDisconnect }) => (
  <div className={classes.container}>
    <StatusColor color={statusColor} />
    <div>
      <h5 className={classes.title}>Pending authorisation</h5>
      <p>
        You have requested us to connect Pobble to your MIS via our data partner
        Wonde. They will contact you to set up authorisation. <br />
        In case of questions please contact{' '}
        <PobbleLink href="mailto:hello@pobble.com">hello@pobble.com</PobbleLink>
        .
      </p>
      <Button
        icon={<UnlinkIcon />}
        secondary
        action={() =>
          openConfirmationDialog({
            bodyText: `Are you sure that you want to break the link between Pobble and your MIS? You will have to manage data in Pobble manually from this point.`,
            confirmText: 'Yes, break the link',
            action: () => onDisconnect(id)
          })
        }>
        Cancel
      </Button>
    </div>
  </div>
)

export default injectSheet(styles)(StatusConnected)
